<template>
  <TableColumnPrimary v-bind="attrs"
                      v-on="$listeners"
                      :header="header"
                      :rows="rows"
                      :width="width">
    <template v-slot:row="props">
      <slot name="row"
            :index="props.index"
            :row="props.row">
        <div :style="innerRowContainerStyle">
          <div :style="userProfileContainerStyle">
            <div :style="userEmailContainerStyle">
              {{ props.row.email }}
            </div>
            <div :style="textContainerStyle">
              <template v-if="props.row.inviters.length">
                <TextRegular
                  :isInline="true"
                  :isNowrap="true"
                >
                  Invited by
                </TextRegular>
                <LinkNamePrimary
                  :isInline="true"
                  :tenantUser="getInviter(props.row)"
                  :truncate="truncate"
                  :style="style.names"
                ><!--
               --><template v-if="invitedByMultipleTenantUsers(props.row)"><!--
                 -->, etc.
                  </template>
                </LinkNamePrimary>
              </template>
            </div>
          </div>
        </div>
      </slot>
    </template>
  </TableColumnPrimary>
</template>

<script>
  import LinkNamePrimary from '@modules/v2/link/link-name-primary'
  import TableColumnPrimary from '@modules/table/table-column-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TableUserColumnPrimary',
    inheritAttrs: false,
    components: {
      LinkNamePrimary,
      TableColumnPrimary,
      TextRegular,
    },
    props: {
      header: { type: String, required: false, default: '' },
      rows: { type: Array, required: false, default: () => [] },
      truncate: { type: Boolean, required: false, default: false },
      width: { type: String, required: false, default: '100%' },
    },
    data: function () {
      return {
        attrs: {
          backgroundColor: 'transparent',
        },
        innerRowContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          justifyContent: 'flex-start',
        },
        truncateStyle: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        userEmailContainerStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.lg,
          //lineHeight: '20px',
        },
        textContainerStyle: {
          //display: 'flex',
          //flexWrap: 'nowrap',
          fontSize: FontStyle.size.sm,
          //lineHeight: FontStyle.size.md,
          maxWidth: '320px',
          width: '100%',
        },
        userNameAttrs: {
          display: 'inline',
        },
        userNameStyle: {
          fontSize: FontStyle.size.sm,
        },
        userProfileContainerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '36px',
        },
        style: {
          names: {
            maxWidth: '210px',
          },
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        ...this.$attrs,
      };

      this.userEmailContainerStyle = {
        ...this.userEmailContainerStyle,
        color: this.color.dark2(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      invitedByMultipleTenantUsers: function (row) {
        return new Set(row.inviters.map(elem => elem.user.id)).size > 1;
      },
      getInviter: function (row) {
        if (!row.inviters.length) {
          return null;
        }
        return row.inviters[0];
      },
      getInviterNames: function (row) {
        return 'test';
      }
    },
  };
</script>
